import ASlogo from "./images/logo.svg";
import AS1stBG from "./images/1stScreenBG.png"
import AS2stSecMobile from "./images/Sec2Mobile.png"
import AS2stSecIcon from "./images/Sec2Icon.svg"
import AS3stSecBG from "./images/Section3BG.png"
import AS4stSecPicture from "./images/Section4Picture.png"
import AS4stSecIcon1 from "./icons/Offline.svg"
import AS4stSecIcon2 from "./icons/HQ.svg"
import AS4stSecIcon3 from "./icons/NoAds.svg"
import AS4stSecIcon4 from "./icons/Skips.svg"
import ASFooterLogo from "./icons/FooterLogo.svg"

export const logo = ASlogo;

export const FirstScrBG = AS1stBG;
export const ThirdScrBG = AS3stSecBG;
export const FourthScrImage = AS4stSecPicture;
export const FooterIcon = ASFooterLogo;
export const FourthScrIcons = {
    icon1 : AS4stSecIcon1,
    icon2 : AS4stSecIcon2,
    icon3 : AS4stSecIcon3,
    icon4 : AS4stSecIcon4
};
export const Section2Mobile = AS2stSecMobile;
export const Section2Icon = AS2stSecIcon;
